import {locale as LOCALE} from '../plugins/i18n';

export const LocaleUtils = {
  methods: {
    getCurrentLocale() {
      return LOCALE;
    },

    renderCurrencyAmount (amount, currency, withCurrency = true, precision = 2) {
      if (currency == null) {
        currency = 'EUR';
        withCurrency = false;
        precision = 2;
      }

      let formattedAmount = new Intl.NumberFormat(LOCALE, {minimumFractionDigits: precision}).format(amount);

      return withCurrency ? formattedAmount + ' ' + currency : formattedAmount;
    },

    trans (messageKey, params) {
      let translated = this.$t(messageKey, params);

      if (translated === messageKey || translated.length === 0) {
        this.$store.dispatch('addUntranslatedMessage', messageKey);
      }

      return translated;
    },

    transc (messageKey, count, params) {
      let translated = this.$tc(messageKey, typeof count === 'undefined' || count === null ? 1 : count, params);

      if (translated === messageKey || translated.length === 0) {
        this.$store.dispatch('addUntranslatedMessage', messageKey);
      }

      return translated;
    },

    transSingular (messageKey, params) {
      return this.transc(messageKey, 1, params)
    },

    transPlural (messageKey, params) {
      return this.transc(messageKey, 2, params)
    }
  }
};
